/**
 * Created by RKL on 26/08/2015.
 */
define('caccountAttachsCollectionView',[
  'module',
  'marionette',
  'app',
  'elementsCollectionView',
  'stateMessages',
  'caccountAttachsItemView',
  'caccountAttachsNewItemView',
  'template!caccountAttachsCollectTpl'
], function (
  module,
  Marionette,
  App,
  ElementsCollectionView,
  StateMessages,
  ItemView,
  NewItemView,
  viewTpl
) {
  'use strict';

  var CAccountsAttachmentsTabCompositeView = ElementsCollectionView.extend({
    template: viewTpl,
    childViewContainer: '.attachments-container',


    getChildView: function(item) {
      if (item.get('id') !== 0) {
        return ItemView;
      } else {
        return NewItemView;
      }
    }
  });

  module.exports = CAccountsAttachmentsTabCompositeView;
});
